import { IAppProviderState, SCREEN_NAME } from '../interface/IAppProvider';
import initialState from '../initialState/initialState';

export interface IStateReducer {
    type: string;
    payload: any;
}

export const appContextReducer = (state: IAppProviderState, action: IStateReducer): IAppProviderState => {
    switch (action.type) {
        case SCREEN_NAME.LOGGED_IN_CUSTOMER_HOUSEHOLD_SIZE:
            return { ...state, loggedInCustomerHouseholdsize: action.payload };
        case SCREEN_NAME.CUSTOMER_CONTENT_STATUS:
            return { ...state, customerContentStatus: action.payload };
        case SCREEN_NAME.INTRO:
            return {
                ...state,
                section: action.payload.resourceBundles,
                contentBlocks: action.payload.contentBlocks
            };
        case SCREEN_NAME.ADDRESS:
            return { ...state, address: action.payload.address };

        case SCREEN_NAME.ALREADYCUSTOMER:
            return { ...state, isCustomer: action.payload.customer };
        case SCREEN_NAME.HOUSEHOLDSIZE:
            return { ...state, householdSize: action.payload };
        case SCREEN_NAME.ALREADYCOVERED:
            return { ...state, alreadyCovered: action.payload };
        case SCREEN_NAME.NOT_ALREADY_COVERED_REASON:
            return { ...state, notAlreadyCoveredReason: action.payload };
        case SCREEN_NAME.CALL_ME:
            return { ...state, telephone: action.payload };
        case SCREEN_NAME.CLAIMTYPE:
            return {
                ...state,
                claimType: action.payload.en,
                claimTypeDanish: action.payload.dk
            };
        case SCREEN_NAME.CLAIMTYPE_SELECTED:
            return { ...state, claimTypeSelected: action.payload };
        case SCREEN_NAME.COMPLIANCE:
            return { ...state, terms: action.payload };
        case SCREEN_NAME.COMPLIANCE_SUBMITTED:
            return { ...state, termsIsSubmitted: action.payload };
        case SCREEN_NAME.NOOFCLAIMS:
            return { ...state, numberOfClaims: action.payload };
        case SCREEN_NAME.CLOUD_BURST:
            return { ...state, cloudBurst: action.payload };
        case SCREEN_NAME.CLAIMAMOUNT:
            return {
                ...state,
                claimAmount: action.payload.amount,
                claimValue: action.payload.value
            };
        case SCREEN_NAME.AGE:
            return { ...state, cprNo: action.payload };
        case SCREEN_NAME.CREATE_PACKAGE:
            return { ...state, createPackage: action.payload };
        case SCREEN_NAME.ABOUT_YOU:
            return { ...state, aboutYouData: action.payload };
        case SCREEN_NAME.SET_ECOMMERCE_PRODUCT:
            return { ...state, ecommerceProduct: action.payload };
        case SCREEN_NAME.PACKAGE_SELECTED:
            return { ...state, selectedPackage: action.payload.selectedPackage };
        case SCREEN_NAME.UPDATED_COVERAGES_DEDUC_SCREEN:
            return { ...state, updatedCoverages: action.payload };
        case SCREEN_NAME.UPDATED_EXTRA_COVERAGES:
            return { ...state, updatedExtraCoverages: action.payload };
        case SCREEN_NAME.DEDUCTIBLE:
            return { ...state, selectedDeductible: action.payload };
        case SCREEN_NAME.TERMINATION:
            return {
                ...state,
                terminationRequested: action.payload.terminationRequested,
                terminationWhen: action.payload.terminationWhen,
                terminationCompany: action.payload.terminationCompany,
                effectiveDate: action.payload.effectiveDate
            };
        case SCREEN_NAME.PAYMENT_SCREEN_ONE:
            return { ...state, bankInfo: action.payload };
        case SCREEN_NAME.PAYMENT_SCREEN_TWO:
            return { ...state, selectedPaymentOption: action.payload };
        case SCREEN_NAME.SET_EMAIL_EVENT:
            return { ...state, emailEvent: action.payload };
        case SCREEN_NAME.SET_SALES_COMPLETE:
            return { ...state, salesComplete: action.payload };
        case SCREEN_NAME.SET_INITIAL_STATE:
            return { ...state, initialState: action.payload };
        case SCREEN_NAME.SET_STATE_CHANGE:
            return { ...state, stateChange: action.payload };
        case SCREEN_NAME.SET_ERROR:
            return { ...state, hasError: action.payload };
        case SCREEN_NAME.RELOAD_STATE:
            return { ...state, ...action.payload.data };
        case SCREEN_NAME.LOADING_DATA:
            return { ...state, isLoading: action.payload };
        case SCREEN_NAME.PRICE_ZERO:
            return { ...state, prizeZero: action.payload };
        case SCREEN_NAME.EMAIL_SENT:
            return { ...state, emailSent: action.payload };
        case SCREEN_NAME.REFRESH_FROM_CACHE:
            return { ...state, refreshFromCache: action.payload };
        case SCREEN_NAME.RESOURCES_READY:
            return { ...state, resourcesReady: action.payload };
        case SCREEN_NAME.SET_BANNER_TEXTS:
            return {
                ...state,
                bannerHeader: action.payload.header,
                bannerText: action.payload.text,
                overlayText: action.payload.overlayText
            };
        case SCREEN_NAME.SHOW_BANNER_OVERLAY:
            return { ...state, showBannerOverlay: action.payload };
        case SCREEN_NAME.RESET_FROM_BACK_BUTTON:
            return { ...initialState, section: action.payload.section, contentBlocks: action.payload.contentBlocks };
        case SCREEN_NAME.SET_EBOKS_SUBSCRIPTION: {
            return { ...state, hasEboksSubscription: action.payload };
        }
        case SCREEN_NAME.SET_GIFT_CARD: {
            return { ...state, giftCard: action.payload };
        }
        case SCREEN_NAME.SET_PROGRESS: {
            return { ...state, actualStep: action.payload, previousStep: state.actualStep };
        }
        case SCREEN_NAME.SET_CUSTOMER_HAS_MARKING: {
            return {
                ...state,
                customerHasMarking: action.payload
            };
        }
        case SCREEN_NAME.SET_IS_LATE_LOGIN: {
            return {
                ...state,
                isLateLogin: action.payload
            };
        }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
